export default class GlitchLink
{
  private readonly wrapper: HTMLElement;
  private readonly letters: NodeListOf<HTMLSpanElement>;
  private readonly orders: number[] = [];

  private readonly mouseEnterHandler: EventListener;
  private readonly mouseMoveHandler: EventListener;
  private readonly mouseLeaveHandler: EventListener;
  
  private isActive: boolean = false;

  constructor(wrapper: HTMLElement)
  {
    this.wrapper = wrapper;
    this.letters = this.wrapper.querySelectorAll('span');

    for (let index = 1; index <= this.letters.length; index++) {
      this.orders.push(index);
    }

    this.mouseEnterHandler = this.handleMouseEnterEvent.bind(this);
    this.mouseMoveHandler = this.handleMouseMoveEvent.bind(this);
    this.mouseLeaveHandler = this.handleMouseLeaveEvent.bind(this);
    


    this.enable();
  }

  private enable(): void
  {
    this.wrapper.addEventListener('mouseleave', this.mouseLeaveHandler, false);
    // this.wrapper.addEventListener('mousemove', this.mouseMoveHandler, false);
    this.wrapper.addEventListener('mouseenter', this.mouseEnterHandler, false);
  }

  public destroy(): void
  {
    this.wrapper.removeEventListener('mouseenter', this.mouseEnterHandler);
    // this.wrapper.removeEventListener('mousemove', this.mouseMoveHandler);
    this.wrapper.removeEventListener('mouseleave', this.mouseLeaveHandler);
  }

  private handleMouseEnterEvent(event: Event): void
  {
    if(event instanceof MouseEvent === false) {
      return;
    }

    const randomizeCount = this.letters.length;
    const randomizeDurationMs = Math.min(100, 350 / randomizeCount);

    this.isActive = true;

    for (let index = 0; index < randomizeCount; index++) {
      setTimeout(() => {
        if(this.isActive) {
          this.randomizeLetterOrder()
        }
      }, index * randomizeDurationMs);
    }

    setTimeout(() => {
      this.resetLetterOrder()
    }, randomizeCount * randomizeDurationMs)
  }

  private handleMouseMoveEvent(event: Event): void
  {
    if(event instanceof MouseEvent === false) {
      return;
    }
  }

  private handleMouseLeaveEvent(event: Event): void
  {
    if(event instanceof MouseEvent === false) {
      return;
    }
    this.isActive = false;
    this.resetLetterOrder();
  }

  private resetLetterOrder(): void
  {
    this.letters.forEach(letter => {
      letter.style.removeProperty('order')
      letter.style.removeProperty('transform');
    });
  }

  private randomizeLetterOrder(): void
  {
    const availableOrders = Array.from(this.orders);
    availableOrders.sort(() => Math.random() - 0.5);

    this.letters.forEach(letter => {
      const order = availableOrders.pop();
      const randBool = (Math.random() > .5);
      letter.style.setProperty('order', String(order));
      letter.style.setProperty('transform', randBool ? 'rotateY(-180deg)' : 'rotateY(0)');
    })
  }
}